import React, { FC, useState } from 'react';
import { Avatar, Badge, Divider, ListItemText, Menu, MenuItem } from '@mui/material';
import { useAuth } from 'oidc-react';
import { getFullname, getInitials } from '../user';
import { UnreadCommentsBadge, ToolbarMenuItem as UserNotificationToolbarMenuItem } from '../home/ToolbarMenuItem';
import gravatarUrl from 'gravatar-url';

export const UserAvatar: FC = () => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const handleMenu = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <UnreadCommentsBadge onClick={handleMenu} style={{ cursor: 'pointer' }}>
        <InitialsAvatar />
      </UnreadCommentsBadge>
      <AvatarMenu anchorEl={anchorEl} onClose={handleClose} />
    </>
  );
};

const InitialsAvatar: FC = () => {
  const auth = useAuth();
  const profile = auth.userData?.profile;
  const initials = getInitials(profile);
  const email = auth.userData?.profile?.email;
  const url = email ? gravatarUrl(email, { size: 200, default: '404' }) : undefined;

  return <Avatar src={url}>{initials}</Avatar>;
};

const AvatarMenu: FC<{ anchorEl: Element | null; onClose: () => void }> = ({ anchorEl, onClose }) => {
  const auth = useAuth();
  const fullname = getFullname(auth.userData?.profile);

  const open = Boolean(anchorEl);

  return (
    <Menu
      id="avatar_menu"
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={onClose}
      open={open}>
      <UserNotificationToolbarMenuItem onClick={onClose} />
      <Divider />
      <MenuItem onClick={() => auth.signOutRedirect()}>
        <ListItemText>Logg ut {fullname}</ListItemText>
      </MenuItem>
    </Menu>
  );
};
